<div class="page_container">
  <div class="static_steps">
    <div class="side_part" cdkDropList #selectedProductsList="cdkDropList" [cdkDropListConnectedTo]="[productsList]"
      [cdkDropListData]="selectedCatalogs" (cdkDropListDropped)="drop($event)">
      <div class="step">
        <div class="step_title inline_title">
          <div>
            <span>{{"Catalogs.catalogs_assigned"|translate}}({{selectedCatalogs.length}})</span>
            <span class="descr_title">{{"Catalogs.drag_and_drop_catalogs_in_this_bloc"|translate}}</span>
          </div>
        </div>
        <div class="inside_content">
          <table class="listing_table">
            <thead class="header_stiky">
              <tr class="head_table">
                <th>{{"companies.catalog_title"|translate}}</th>
                <th>{{"common.wholesale"|translate}} <br> {{"Catalogs.discount"|translate}}</th>
                <th>{{"quotations_and_orders.product"|translate}}</th>
                <th>{{"common.location"|translate}}</th>
                <th>{{"common.remove"|translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let catalog of selectedCatalogs; let i = index; trackBy: trackByFn"
                class="body_table hover_tr" cdkDrag>
                <td class="td_block">
                  <span class="bold_span">{{ catalog.name }}</span><br>
                </td>
                <td class="td_actions">
                  <span class="bold_span">{{catalog.general_discount}}%</span>
                </td>
                <td>{{catalog.nbr_products}}</td>
                <td>{{catalog.nbr_locations}}</td>
                <td>
                  <button *appHasPermission="{ module: 'product', action: 'edit' }" (click)="removeCatalog(catalog)">
                    <img src="assets/icones/red-delete-icon.svg" alt="">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="side_part" cdkDropList #productsList="cdkDropList" [cdkDropListConnectedTo]="[selectedProductsList]"
      [cdkDropListData]="catalogs" (cdkDropListDropped)="drop($event)">
      <div class="step">
        <div class="step_title inline_title">
          <div>
            <span>{{"Catalogs.all_catalog"|translate}} ({{catalogs.length}})</span>
            <span class="descr_title">{{"Catalogs.drag_and_drop_catalogs"|translate }}</span>
          </div>
          <div class="field">
            <input class="input" type="text" [placeholder]="'Catalogs.search_catalogs'|translate" [formControl]="search" />
            <img src="assets/icones/search.svg" class="indicate_input" alt="">
          </div>
        </div>
        <div class="inside_content">
          <table class="listing_table">
            <thead class="header_stiky">
              <tr class="head_table">
                <th>{{"companies.catalog_title"|translate}}</th>
                <th>{{"common.wholesale"|translate}} <br> {{"Catalogs.discount"|translate}}</th>
                <th>{{"quotations_and_orders.product"|translate}}</th>
                <th>{{"common.location"|translate}}</th>
                <th>{{"common.add"|translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let catalog of catalogs; let i = index; trackBy: trackByFn" class="body_table hover_tr"
                cdkDrag>
                <td class="td_block">
                  <span class="bold_span">{{ catalog.name }}</span><br>
                </td>
                <td class="td_actions">
                  <span class="bold_span">{{catalog.general_discount}}%</span>
                </td>
                <td>{{catalog.nbr_products}}</td>
                <td>{{catalog.nbr_locations}}</td>
                <td>
                  <button *appHasPermission="{ module: 'product', action: 'edit' }" (click)="addCatalog(catalog)">
                    <img src="assets/icones/black-add-icon.svg" alt="">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="submet_btns">
    <button class="save_btn_pop_up cancel_btn_pop_up" (click)="cancel()">{{"Catalogs.CANCEL"|translate}}</button>
    <button class="save_btn_pop_up blue_btn" *appHasPermission="{ module: 'product', action: 'edit' }" (click)="save()">
      <span>{{"Catalogs.insert_catalogs"|translate}}</span>
      <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
    </button>
  </div>
</div>
